<section class="org-contacts container py-4" aria-labelledby="org-contacts-title">
	<div class="d-flex justify-content-between align-items-center mb-3">
		<h3 id="org-contacts-title" class="mb-0">Osoby kontaktowe</h3>
		<button mat-raised-button color="primary" type="button" [disabled]="isLoading()" (click)="openDialog(null)">
			<i class="fa-solid fa-user-plus me-1" aria-hidden="true"></i>
			Dodaj osobę kontaktową
		</button>
	</div>

	@if (isLoading()) {
		<div class="org-contacts__state" role="status">
			<i class="fa-solid fa-spinner fa-spin me-2" aria-hidden="true"></i>
			Ładowanie osób kontaktowych…
		</div>
	} @else if (loadFailed()) {
		<div class="org-contacts__state org-contacts__state--error" role="alert">
			<span>Nie udało się pobrać osób kontaktowych.</span>
			<button mat-stroked-button type="button" (click)="load()">Spróbuj ponownie</button>
		</div>
	} @else if (rows().length === 0) {
		<div class="org-contacts__state">
			<span>Brak osób kontaktowych. Dodaj pierwszą osobę albo potwierdź organizację w zapytaniu grupowym.</span>
		</div>
	} @else {
		<div class="table-responsive">
			<table class="table table-hover align-middle org-contacts__table">
				<thead>
					<tr>
						<th scope="col">Osoba</th>
						<th scope="col">Stanowisko</th>
						<th scope="col">E-mail</th>
						<th scope="col">Telefon</th>
						<th scope="col">Dział</th>
						<th scope="col">Źródło</th>
						<th scope="col" class="text-end"><span class="visually-hidden">Akcje</span></th>
					</tr>
				</thead>
				<tbody>
					@for (row of rows(); track row.contact.id) {
						<tr>
							<td class="fw-semibold">{{ row.fullName }}</td>
							<td>{{ row.contact.position || '—' }}</td>
							<td>
								@if (row.contact.email) {
									<a [href]="'mailto:' + row.contact.email">{{ row.contact.email }}</a>
								} @else {
									—
								}
							</td>
							<td>
								@if (row.contact.phone) {
									<a [href]="'tel:' + row.contact.phone">{{ row.contact.phone }}</a>
								} @else {
									—
								}
							</td>
							<td>{{ row.departmentName || '—' }}</td>
							<td>
								@if (row.contact.sourceLead) {
									<a
										[routerLink]="['/leads/group', row.contact.sourceLead]"
										target="_blank"
										rel="noopener"
										matTooltip="Otwórz zapytanie w nowej karcie"
									>
										<i class="fa-solid fa-arrow-up-right-from-square me-1" aria-hidden="true"></i>
										Zapytanie
									</a>
								} @else {
									<span class="text-muted">Ręcznie</span>
								}
							</td>
							<td class="text-end text-nowrap">
								<button
									mat-icon-button
									type="button"
									matTooltip="Edytuj"
									[attr.aria-label]="'Edytuj osobę ' + row.fullName"
									[disabled]="deletingId() === row.contact.id"
									(click)="openDialog(row.contact)"
								>
									<i class="fa-solid fa-pen" aria-hidden="true"></i>
								</button>
								<button
									mat-icon-button
									type="button"
									color="warn"
									matTooltip="Usuń"
									[attr.aria-label]="'Usuń osobę ' + row.fullName"
									[disabled]="deletingId() === row.contact.id"
									(click)="remove(row)"
								>
									<i class="fa-solid fa-trash" aria-hidden="true"></i>
								</button>
							</td>
						</tr>
					}
				</tbody>
			</table>
		</div>
	}
</section>
